'use client';

import React from 'react';
import { authorByName, personSchema } from '@/lib/authors';

interface ArticleSchemaProps {
  headline: string;
  description: string;
  author?: {
    name: string;
    url?: string;
  };
  datePublished: string;
  dateModified?: string;
  image?: string;
  articleBody?: string;
  url: string;
  type?: 'Article' | 'BlogPosting';
}

const ArticleSchema: React.FC<ArticleSchemaProps> = ({
  headline,
  description,
  author,
  datePublished,
  dateModified,
  image,
  articleBody,
  url,
  type = 'Article'
}) => {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": type,
    "headline": headline,
    "description": description,
    // Known authors get the full Person, credential included (#458).
    "author": authorByName(author?.name) ? personSchema(authorByName(author?.name)!) : author ? {
      "@type": "Person",
      "name": author.name,
      ...(author.url && { "url": author.url })
    } : {
      "@type": "Organization",
      "name": "Delphina"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Delphina",
      "logo": {
        "@type": "ImageObject",
        "url": "https://delphina.money/logo.png"
      }
    },
    "datePublished": datePublished,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    }
  };

  if (dateModified) {
    schema.dateModified = dateModified;
  }

  if (image) {
    schema.image = {
      "@type": "ImageObject",
      "url": image
    };
  }

  if (articleBody) {
    schema.articleBody = articleBody;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default ArticleSchema;
